import { API_CALL } from 'actions/actionConstants'
import { FETCH_WHITE_LABEL_APP_PROMO_CODE_BY_MEMBER_ID, IGNORE_WHITE_LABEL_APP_PROMO_FOR_MEMBER_ID } from 'actions/apiActionConstants'
import { getWhiteLabelAppPromoByMemberId, patchIgnoreWhiteLabelAppPromoForMemberId } from 'api/whiteLabelApp'

export function fetchWhiteLabelAppPromoByMemberId({ memberId, externalProviderName }: { memberId: string, externalProviderName: string }) {
  return {
    type: API_CALL,
    api: FETCH_WHITE_LABEL_APP_PROMO_CODE_BY_MEMBER_ID,
    request: () => getWhiteLabelAppPromoByMemberId({ memberId, externalProviderName }),
  }
}

export function ignoreWhiteLabelAppPromoForMemberId({ memberId, promoCode }: { memberId: string, promoCode: string }) {
  return {
    type: API_CALL,
    api: IGNORE_WHITE_LABEL_APP_PROMO_FOR_MEMBER_ID,
    request: () => patchIgnoreWhiteLabelAppPromoForMemberId({ memberId, promoCode }),
  }
}
